export default {
  en: [],
  sv: [
    {
      code: 301,
      newPath: '/restauranger',
      oldPaths: [
        '/restaurang'
      ]
    },
    {
      code: 301,
      newPath: '/exclusive/skaldjursveckorna',
      oldPaths: [
        '/skaldjursveckorna'
      ]
    },
    {
      code: 301,
      newPath: '/exclusive/stockholm-food-weeks',
      oldPaths: [
        '/stockholm-food-weeks'
      ]
    }
  ]
}